import ClaimDetailScreen from '../components/ClaimDetailScreen';
import ConfirmationScreen from '../components/ConfirmationScreen';
import DocumentationScreen from '../components/DocumentationScreen';
import PolicyDetailScreen from '../components/PolicyDetailScreen';
import SubmitterDetailScreen from '../components/SubmitterDetailScreen';
import { translations } from './consts';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: PolicyDetailScreen,
        step: 0,
        label: translations.stepLabel.START,
    },
    {
        path: '/stepTwo',
        screen: SubmitterDetailScreen,
        step: 1,
        label: translations.stepLabel.SUBMITTER,
    },
    {
        screen: DocumentationScreen,
        path: '/stepThree',
        step: 2,
        label: translations.stepLabel.DOCUMENTATION,
    },
    {
        path: '/stepFour',
        screen: ConfirmationScreen,
        step: 3,
        label: translations.stepLabel.CONFIRMATION,
    },
];

export default stepsComposer;
